import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";
import {appEnv} from "@app/api/appEnv.ts";

const apiDataBridge = createApi({
    reducerPath: 'apiDataBridge',
    baseQuery: axiosBaseQuery(appEnv.DATABRIDGE_BASEURL),
    endpoints: () => ({}),
    tagTypes: ['COMPANIES', 'COMPANIES-PROCESS', 'PROCESS']
});

export default apiDataBridge;
